module.exports = {
		getDefaultProperty : function(o , propertyName, defaultValue){
			return (o !== undefined && o[prop] !== undefined)?  o[prop] : defaultValue;
		},
		
		isHttps : function(){
			return location.protocol === 'https:';
		},
		
		createUrl : function(base, path ,params){
			var url = base;
			if(path !== undefined){
				url += path;
			}
			if(params !== undefined){
				url += "?" + $.param(params);
			}
			return url;
		},

		hexToBase64 : function(hexString){
			var binaryArray = new Uint8Array(hexString.length / 2);
			for(var i = 0 ; i < hexString.length; i+=2){
				binaryArray[i/2] = parseInt(hexString[i] + hexString[i+1],16);
			}
			return btoa( String.fromCharCode.apply(null, binaryArray) );
		},

		base64ToHex : function(base64String){
			//convert to binary and interpret byte values as characters of a string
			var binaryString = atob(base64String);
			var hexString = "";
			for(var i = 0; i < binaryString.length; i++){
				//convert charachter to byte value
				var byteValue = binaryString.charCodeAt(i);
				//convert byte value to a hex string
				hexString += byteValue.toString(16);
			}
			return hexString;


		}

};